export default {"src":"/_next/static/media/payment-mastercard.e1bf6994.svg","height":30,"width":44,"blurWidth":0,"blurHeight":0};